<template>
  <div v-if="isReady">
    <div class="container mx-auto mb-4 md:mb-8">
      <transition name="fade" mode="out-in">
        <div :key="`image-${currentImageIndex}`">
          <img :src="currentImage.file_name"  class="mx-auto mb-4 md:mb-8">
        </div>
      </transition>
    </div>

    <div class="mb-4 md:mb-8 text-center container mx-auto">
      <div
        class="inline-block mr-2 mb-2 rounded-full st-bgc h-4 w-4 cursor-pointer"
        :class="currentImageIndex == i ? 'bg-blue-300' : 'bg-blue-400 hover:bg-blue-300'"
        :key="`image-page-${i}`"
        v-for="(image, i) in images"
        @click="selectImage(i)"></div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'image-slider',
  props: {
    images: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentImage: null,
      currentImageIndex: 0,
      isReady: false,
    }
  },
  methods: {
    selectImage(index) {
      this.currentImageIndex = index;
      this.currentImage = this.images[this.currentImageIndex];
    },
  },
  mounted() {
    this.currentImage = this.images[0];
    this.isReady = true;
  }
}
</script>